import { Trans, useTranslation, type WithTranslation } from "react-i18next";
import { Alert, Stack } from "~/common/mui";
import { NewVersionMessage } from "~/common/components/Messages/NewVersionMessage";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";
import type { QuoteLineMO } from "~/features/orders/common/components/v2/models";

interface Props {
  entry: QuoteLineMO;
  className?: string;
}

export const QuoteLineMessages = ({ entry, className }: Props) => {
  const { t } = useTranslation();

  if (entry.messages.length === 0 && !NewVersionMessage.isVisible(entry.product)) {
    return null;
  }

  return (
    <Stack gap={1} className={className} sx={{ gridColumn: "1 / -1" }}>
      <NewVersionMessage baseProduct={entry.product} />
      {entry.messages.map((code) => getMessage(t, code))}
    </Stack>
  );
};

function getMessage(t: WithTranslation["t"], code: string) {
  let msg;
  if (code === "page.quoteDetails.message.notAvailable") {
    msg = (
      <Trans i18nKey={code}>
        Item not available for checkout. Please <a href={URL_CONTACT_US}>contact customer service</a>.
      </Trans>
    );
  } else {
    msg = t(code);
  }
  return (
    <Alert key={code} severity="info">
      {msg}
    </Alert>
  );
}
